module.exports = __webpack_public_path__ + "img/image_part_003.ee66f946.jpg";